import { useMutation, useQueryClient } from '@tanstack/react-query';
import { dataSelector } from '@nextiva/global-store';
import { useSelector } from 'react-redux';
import { updateEnablementInfo } from 'services';
import { EnablementInfoPayloadV3 } from 'interface/WizardV3';
import { useSnackbar } from 'hooks';
import { ENABLEMENT_INFO_KEY } from '../constants';

export function useUpdateEnablementInfo() {
  const globalStoreData = useSelector(dataSelector);
  const corpAcctNbr = globalStoreData.user?.profileDTO?.corpAcctNbr;
  const queryClient = useQueryClient();

  const errorMessage = 'Something went wrong, please try again later.';
  const setSnackbar = useSnackbar();

  return useMutation({
    mutationFn: (payload: EnablementInfoPayloadV3) =>
      updateEnablementInfo(corpAcctNbr, payload),
    onMutate: async (payload) => {
      await queryClient.cancelQueries([ENABLEMENT_INFO_KEY]);
      const previousData = queryClient.getQueryData([ENABLEMENT_INFO_KEY]);
      queryClient.setQueryData(
        [ENABLEMENT_INFO_KEY],
        (old: EnablementInfoPayloadV3) => {
          return { ...old, ...payload };
        },
      );
      return { previousData };
    },
    onError: (error) => {
      const errorResponse = error as {
        response?: { data?: { displayMessage?: string } };
      };
      setSnackbar({
        message: errorResponse?.response?.data?.displayMessage || errorMessage,
        severity: 'error',
      });
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      queryClient.invalidateQueries([ENABLEMENT_INFO_KEY]);
    },
  });
}
